import sanitizeHtml from "sanitize-html";
import { V3ArticleView } from "../ReusableStyledComponents/V3ArticleView";
import { nofollowLinks } from "../../utils/nofollowLinks";

interface PodcastItemHtmlProps {
    html: string;
}

/**
 * Podcast show notes, sanitized because they come from third party RSS feeds. Kept in its own module so
 * sanitize-html only loads for podcast items.
 * @param props The prepared show notes html
 * @returns The sanitized show notes
 */
export default function PodcastItemHtml({ html }: PodcastItemHtmlProps) {
    return (
        <V3ArticleView suppressHydrationWarning>
            <div
                dangerouslySetInnerHTML={{
                    __html: nofollowLinks(
                        sanitizeHtml(html, {
                            allowedTags: sanitizeHtml.defaults.allowedTags.concat(["img", "figure"])
                        })
                    )
                }}
                suppressHydrationWarning
            />
        </V3ArticleView>
    );
}
